/* eslint-disable @typescript-eslint/no-unused-vars */
import { logger } from '@kamernet/core/Logger';

import { ConstantsLDP } from '../types';

export const calculateSupplyProducts = (
  moveUpDate: string | null,
  freeMoveUpDate: string | null,
  isTopAdvert: boolean,
  isReactForFree: boolean,
) => {
  try {
    const now = new Date();

    // Calculate moveUpDays and isMoveUp
    const moveUpDays = moveUpDate
      ? (now.getTime() - new Date(moveUpDate).getTime()) / (1000 * 3600 * 24)
      : null;
    const isMoveUp =
      moveUpDays !== null && moveUpDays <= ConstantsLDP.MoveUpDuration;

    // Calculate freeMoveUpDays and isFreeMoveUp
    const freeMoveUpDays = freeMoveUpDate
      ? (now.getTime() - new Date(freeMoveUpDate).getTime()) /
        (1000 * 3600 * 24)
      : null;
    const isFreeMoveUp =
      freeMoveUpDays !== null &&
      freeMoveUpDays <= ConstantsLDP.FreeMoveUpDuration;

    // Determine if 'fresh start' is true or false
    const isFreshStart = isMoveUp || isFreeMoveUp;

    // Construct listSupplyProducts
    const listSupplyProducts = {
      'top ad': isTopAdvert,
      'react for free': isReactForFree,
      'fresh start': isFreshStart,
    };

    // Determine active supply products
    const activeSupplyProducts = Object.entries(listSupplyProducts)
      .filter(([_, value]) => value)
      .map(([key, _]) => key);

    return activeSupplyProducts;
  } catch {
    logger.error('calculateSupplyProducts analytics event failed');
    return [];
  }
};
